import { render, staticRenderFns } from "./detailSalesAnalysisTable.vue?vue&type=template&id=cf84b266&scoped=true&"
import script from "./detailSalesAnalysisTable.vue?vue&type=script&lang=js&"
export * from "./detailSalesAnalysisTable.vue?vue&type=script&lang=js&"
import style0 from "./detailSalesAnalysisTable.vue?vue&type=style&index=0&id=cf84b266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf84b266",
  null
  
)

export default component.exports